<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" fullscreen persistent width="720" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet class="scroll-primary pr-10" style="flex: 0 1 auto; overflow-y: auto; overflow-x: hidden">
                <vertical-form-table v-model="form" v-bind="{ items }">
                    <template #프로그램>
                        <span class="page-text--sm"> {{ program.subject }} </span>
                    </template>
                    <template #문의>
                        <div class="page-text--sm">
                            <p class="mb-16">제목: {{ form.subject }}</p>
                            <p class="mb-16">내용: {{ form.content }}</p>

                            <v-row class="row--small mt-14 font-size-12">
                                <v-col cols="auto">
                                    작성자:
                                    {{ form?.user?.name }}
                                </v-col>
                                <template v-if="form.createdAt">
                                    <v-col cols="auto">·</v-col>
                                    <v-col cols="auto">
                                        작성일시:
                                        {{ form?.createdAt?.toDateTime?.() }}
                                    </v-col>
                                </template>
                                <template v-if="form.updatedAt">
                                    <v-col cols="auto">·</v-col>
                                    <v-col cols="auto">
                                        갱신일시:
                                        {{ form?.updatedAt?.toDateTime?.() }}
                                    </v-col>
                                </template>
                            </v-row>
                        </div>
                    </template>
                </vertical-form-table>
            </v-sheet>
            <div class="v-btn-group">
                <v-btn outlined color="secondary" class="min-w-140px min-w-lg-160px" @click="resetRepliedAt">
                    <span> 답변시간 갱신 </span>
                </v-btn>
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="shows = false">
                    <span class="grey-6--text"> 취소 </span>
                </v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="save">
                    <span> {{ execText }} </span>
                </v-btn>
            </div>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { attrs_input } from "@/assets/variables/attrs";
import { initExpoProgram, initExpoInquiry } from "@/assets/variables/inits";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    {
        term: "프로그램",
    },
    {
        term: "문의",
    },
    {
        key: "reply",
        term: "답변",
        type: "textarea",
    },
    {
        key: "repliedAt",
        term: "답변시간",
        type: "datetime",
    },
].map((item) => ({
    ...attrs_input,
    ...item,
    attrs_input,
}));

export default {
    components: {
        BottomSheet,
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initExpoInquiry },
        program: { type: Object, default: initExpoProgram },
    },
    data: () => ({
        form: initExpoInquiry({
            repliedAt: Date.now(),
        }),

        shows: false,
        loading: false,

        items,
    }),
    computed: {
        isReplied() {
            return this.value?.isReplied;
        },
        _program() {
            return this.program._id;
        },
        title() {
            let title = "문의하기";

            if (this.isReplied) title += " 답변수정";
            else title += " 답변생성";

            return title;
        },
        execText() {
            if (this.isReplied) return "수정하기";
            else return "생성하기";
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
            else if (this.form?._id) this.$emit("input", this.form);
        },
    },
    methods: {
        async init() {
            this.loading = true;
            try {
                let { inquiry } = await api.v1.expo.programs.inquiries.get({
                    _id: this.value._id,
                    _program: this._program,
                });
                this.form = initExpoInquiry({ ...inquiry, repliedAt: inquiry.repliedAt || Date.now() });
            } finally {
                this.loading = false;
            }
        },

        validate() {
            try {
                if (!this.form.reply) {
                    throw new Error("제목을 입력해주세요");
                }

                if (!this.form.content) {
                    throw new Error("제목을 입력해주세요");
                }

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },

        async save() {
            if (!this.validate()) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { _id, reply, repliedAt } = this.form;
                let form = {
                    _id,
                    _program: this._program,
                    reply,
                    repliedAt,
                };

                let { inquiry } = await api.v1.expo.programs.inquiries.put(form);

                this.form = initExpoInquiry(inquiry);
                this.$emit("input", this.form);
                this.shows = false;
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        resetRepliedAt() {
            this.form.repliedAt = Date.now();
            this.emit();
        },

        async emit() {
            this.form = initExpoInquiry(this.form);
        },
    },
};
</script>
